<template>
  <mu-dialog :open='true' dialogClass="modal-mu-dialog">
        <div class="modal-wrapper" id = 'account-info-print'>
          <div class="modal-container">
            <div class="print-wraper">
              <div class="print-content">
                <div class="print-content-header">
                  <div class="header-title-wrap">
                    <div class="header-logo"></div>
                    <div class="header-title">六六脑<sup>®</sup>{{system_name}}</div>
                  </div>
                </div>
                <div class="print-content-con">
                  <div class="print-accout">
                    <div class="print-accout-title">
                      <span>康复账号</span>
                    </div>
                    <div class="print-accout-name">
                      <span class="accout-item">姓名:</span>
                      <span>{{caseInfo.name}}</span>
                    </div>
                    <div class="print-accout-login">
                      <span class="accout-item">登录账号:</span>
                      <span>{{caseInfo.username}}</span><br/>
                    </div>
                    <div class="print-accout-age">
                      <span class="accout-item">年龄:</span>
                      <span>{{caseInfo.age}}岁</span>
                    </div>
                    <div class="print-accout-dr">
                      <span class="accout-item">医生:</span>
                      <span>{{caseInfo.addUser}}</span>
                    </div>
                    <div class="print-accout-sex">
                      <span class="accout-item">性别:</span>
                      <span>{{sex}}</span>
                    </div>
                    <div class="print-accout-agency">
                      <span class="accout-item">机构:</span>
                      <span>{{caseInfo.department}}</span>
                    </div>
                  </div>
                </div>
                <div class="print-content-desc">
                  <div class="print-desc">
                    <div class="print-desc-title">
                      <span>使用说明</span>
                    </div>
                    <ul class="desc-wrap">
                      <li>
                        <span class="desc-title">首次</span><br/>
                        <span class="desc-content">首次使用时，建议在医生指导下进行。<br/>如果有任何疑问，请及时咨询。<br/>之后，医生会逐渐地让您独立操作。</span>
                      </li>
                      <li>
                        <span class="desc-title">登录</span><br/>
                        <span class="desc-content">网址：<span style="color:#151515;font-weight:bold;">kangfu.66nao.com</span><br/>
                        在登录页面，请输入“账号”和“密码”（见康复账号信息，初始密码为</span>
                        <span style="color:#151515;font-weight:bold;">123456</span>
                        <span class="desc-content">)</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <a ref="print" class="print" @click="printNow">打印</a>
              <a ref="cancel" class="cancel" @click="cancelPrint">关闭</a>
            </div>
          </div>
        </div>
  </mu-dialog>
<!--
  <div id="modal">
      <div class="modal-mask">
      </div>
    </div>
-->
</template>
<script>
  export default({
    data(){
      return{
        maskNode: null,
        system_name: g_system_preferences.name,
      }
    },
    computed:{
      sex(){
        if (this.caseInfo.gender == 2) {
          return "男";
        }else{
          return "女";
        }
      }
    },
    methods:{
      cancelPrint () {
        this.$emit("close");
      },
      printNow () {
        document.querySelector(".print").style.display = "none";
        document.querySelector(".cancel").style.display = "none";
        
        let info = document.getElementById("account-info-print");
        this.maskNode = info.parentElement.parentElement.parentElement.previousElementSibling;
        let opacity = this.maskNode.style.opacity;
        let backgroundColor = this.maskNode.style.backgroundColor;
        this.maskNode.style.opacity = 1;
        this.maskNode.style.backgroundColor = '#FFF';
        // document.querySelector(".modal-mask").style.backgroundColor = "#FFF";
         window.print();
        this.$parent.showModal = false;
        document.querySelector(".print").style.display = "block";
        // document.querySelector(".modal-mask").style.backgroundColor = "rgba(0,0,0,0.5)";
        this.maskNode.style.opacity = opacity;
        this.maskNode.style.backgroundColor = backgroundColor;
        document.querySelector(".cancel").style.display = "block";
      }
    },
    props:["caseInfo"],
    mounted: function()
    {
      let info = document.getElementById("account-info-print");
      info.parentElement.parentElement.setAttribute('class', '');
    },
  })
</script>
<style lang="stylus" scoped>
.modal-container
  position relative
  width  420px
  height 594px
  font-family "Microsoft YaHei"
  .print-wraper
    position relative
    box-sizing border-box
    width 420px
    height 594px
    border 1px solid #999
    .print-content
      width 420
      height 515px
      .print-content-header
        width 420px
        height 80px
        .header-title-wrap
          position relative
          width 420px
          height 80px
          background-color #0A81E5
          margin 0
          .header-logo
            position absolute
            width 49.8px
            height 36px
            background-image url("../../../../assets/img/logo_s.png")
            background-repeat no-repeat
            left 20px
            top 50%
            transform translateY(-50%)
          .header-title
            height 80px
            padding-left 80px
            color #fff
            text-align left
            line-height 81px
            font-size 19px
      .print-content-con
        width 420px
        height 200px
        .print-accout
          width 340px
          height 150px
          margin 0 auto
          /*padding 10px 0px 0 10px;*/
          .print-accout-title
            font-size 16px
            text-align left
            color #333
          .print-accout-name,.print-accout-age,.print-accout-sex
            width 170px
            height 42px
            line-height 42px
            float left
            text-align left
            font-size 14px
            font-weight bold
            .accout-item
              color #999
              font-weight 400
          .print-accout-login,.print-accout-dr,.print-accout-agency
            width 170px
            height 42px
            line-height 42px
            float right
            text-align left
            font-size 14px
            font-weight 400
            font-weight bold
            .accout-item
              color #999
              font-weight 400       
      .print-content-desc
        width 420px
        height 235px
        .print-desc
          width 340px
          height 235px
          margin 0 auto
          /*padding 0px 40px*/
          .print-desc-title
            font-size 16px
            text-align left
            color #333
          .desc-wrap
            text-align left
            height 211px
            margin 0
            .desc-title
              font-size 14px
              line-height 20px
            .desc-content
              font-size 14px
              line-height 20px
              color #999
    .print
      position absolute
      font-size 14px
      bottom 20px
      right 20px
      color #0A81E5
      text-decoration underline
      cursor pointer
    .cancel
      position absolute
      font-size 14px
      bottom 20px
      right 68px
      color #999
      text-decoration underline
      cursor pointer
</style>



// WEBPACK FOOTER //
// printInfo.vue?3eadf26c